import { defineComponent as _defineComponent } from 'vue'
import InlineSvg from "vue-inline-svg";
import { computed, ref } from "vue";

interface RmpIconProps {
	src: string;
	color?: string;
	hoverColor?: string;
	height?: string | number;
	width?: string | number;
	size?: string | number;
	tooltip?: string;
	right?: boolean;
	tooltipPosition?: "bottom" | "right";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpIcon',
  props: {
    src: null,
    color: null,
    hoverColor: { default: undefined },
    height: null,
    width: { default: "fit-content" },
    size: null,
    tooltip: null,
    right: { type: Boolean },
    tooltipPosition: { default: "bottom" }
  },
  setup(__props: any) {

const props = __props as { src: string, color?: string, hoverColor: string, height?: string | number, width: string | number, size?: string | number, tooltip?: string, right?: boolean, tooltipPosition: "bottom" | "right" };



const isHovered = ref(false);

const styleObject = computed(() => {
	return {
		color: props.color
	};
});

const svgStyles = computed(() => {
	return {
		height: props.size || props.height,
		width: props.size || props.width,
		color: isHovered.value && props.hoverColor ? props.hoverColor : props.color,
		transition: "color 0.2s ease"
	};
});

const processedSrc = computed(() => {
	return `/img/icons/${props.src}.svg`;
});

return { __sfc: true,props, isHovered, styleObject, svgStyles, processedSrc, InlineSvg }
}

})